
export const webUrl = 'https://ilogically.com'; 
export const webUrlNode = 'https://api.ilogically.com';// appToken.js

// export const primaryColor='rgba(83, 89, 103,1)';
// export const primaryColorOp5='rgba(83, 89, 103,1)'; 
// export const buttonColorOp5='rgba(83, 89, 103,1)';
// export const iconColorInfo='rgba(83, 89, 103,0.9)';   
// export const activityColorOp0='rgba(83, 89, 103,0.1)';  

// export const primaryColor='rgba(43, 156, 181,1)';
// export const primaryColorOp5='rgba(43, 156, 181,1)'; 
// export const buttonColorOp5='rgba(43, 156, 181,0.9)';  
// export const iconColorInfo='rgba(83, 89, 103,0.9)';  
// export const activityColorOp0='rgba(43, 156, 181,0.1)';  
// Green 
export const primaryColor='rgba(1, 64,89,1)';
export const primaryColorOp5='rgba(1, 64,89,1)'; 
export const buttonColorOp5='rgba(1, 64,89,0.9)';  
export const iconColorInfo='rgba(1, 64,89,0.9)';  
export const activityColorOp0='rgba(1, 64,89 ,0.1)';  

// red
// export const primaryColor='rgba(255, 102, 102,1)';
// export const primaryColorOp5='rgba(255, 102, 102,1)'; 
// export const buttonColorOp5='rgba(255, 102, 102,0.9)';  
// export const iconColorInfo='rgba(83, 89, 103,0.9)';  
// export const activityColorOp0='rgba(255, 102, 102,0.1)';  

// brown
// export const primaryColor='rgba(153, 102, 51,1)';
// export const primaryColorOp5='rgba(153, 102, 51,1)'; 
// export const buttonColorOp5='rgba(153, 102, 51,0.9)';  
// export const iconColorInfo='rgba(83, 89, 103,0.9)';  
// export const activityColorOp0='rgba(153, 102, 51,0.1)';  

//Pink
// export const primaryColor='rgba(204, 102, 153,1)';
// export const primaryColorOp5='rgba(204, 102, 153,1)'; 
// export const buttonColorOp5='rgba(204, 102, 153,0.9)';  
// export const iconColorInfo='rgba(83, 89, 103,0.9)';  
// export const activityColorOp0='rgba(204, 102, 153,0.1)';  


// Skin

// export const primaryColor='rgba(255, 204, 153,1)';
// export const primaryColorOp5='rgba(255, 204, 153,1)'; 
// export const buttonColorOp5='rgba(255, 204, 153,0.9)';  
// export const iconColorInfo='rgba(83, 89, 103,0.9)';  
// export const activityColorOp0='rgba(255, 204, 153,0.1)';